//New Application
import Login from "../views/login/Login";
import HomePage from "../views/homepage/HomePage";
import VerifyEmail from "../views/NewApplication/VerifyEmail";
import VerifyOtp from "../views/NewApplication/VerifyOtp";
import ApplicantsDetails from "../views/NewApplication/ApplicantsDetails";
import ProofOfTrust from "../views/NewApplication/ProofOfTrust";
import ApplicantsIdentification from "../views/NewApplication/ApplicantsIdentification";
import CoBorrowersDetails from "../views/NewApplication/Co-BorrowersDetails";
import IdentificationOfCoBorrower from "../views/NewApplication/IdentificationOfCo_Borrower ";
import ApplicantProfessionalDetails from "../views/NewApplication/ApplicantProfessionalDetails";
import UploadDocumentsOne from "../views/NewApplication/UploadDocuments1";
import UploadDocumentsPreview from "../views/NewApplication/UploadDocumentsPreview";
//import UploadDocumentsTwo from "../views/NewApplication/UploadDocuments2";
//import UploadDocumentsThree from "../views/NewApplication/UploadDocuments3";
import Liquidity from "../views/NewApplication/Liquidity";
import RealEstateAssets from "../views/NewApplication/RealEstateAssets";

import BusinessAssets from "../views/NewApplication/BusinessAssets";
import PartnershipInterests from "../views/NewApplication/PartnershipInterests";
import PersonalHolding from "../views/NewApplication/PersonalHolding";
import LiabilitiesForm from "../views/NewApplication/Liabilities";
import IncomeSources from "../views/NewApplication/IncomeSources";
import Expenses from "../views/NewApplication/Expenses";
import Dashboard from "../views/NewApplication/Dashboard";

import BalanceSheetTotalAssets from "../views/NewApplication/BalanceSheetTotalAssets";
import Questionnaire from "../views/NewApplication/BalanceSheetQuestionnaire";
import BalanceSheetAssets from "../views/NewApplication/BalanceSheetAssets";
import BalanceSheetTotalLiabilities from "../views/NewApplication/BalanceSheetTotalLiabilities";

//User Account
import RegisteredEmail from "../views/UserAccount/RegisteredEmail";
import RegisteredEmailOtp from "../views/UserAccount/RegisteredEmailOtp";

//Application Status
import ApplicationStatus from "../views/ApplicationStatus/ApplicationStatus";

//Banker UI
import LoanApplications from "../views/BankerUI/LoanApplications";
import RevisionRequest from "../views/BankerUI/RevisionRequest";
import BankerDashboard from "../views/BankerUI/BankerDashboard";
import Sponsors from "../views/BankerUI/Sponsors";
import FacilityDetails from "../views/BankerUI/FacilityDetails";
import MyApplications from "../views/UserAccount/MyApplications";
import EnterEmail from "../views/BankerUI/EnterEmail";
import AccountLogin from "../views/BankerUI/AccountLogin";
//import RecoveryDetails from "../views/BankerUI/RecoveryDetails";
import ForgottenPassword from "../views/BankerUI/ForgottenPassword";
import ForgotUserLoginPassword from "../views/NewApplication/ForgotUserLoginPassword";
import VerifyEmailOtp from "../views/BankerUI/VerifyEmailOtp";
import VerifyBankerRolesOtp from "../views/BankAdmin/VerifyBankerRolesOtp";
import PersonalDetails from "../views/BankerUI/PersonalDetails";
import ProfessionalDetails from "../views/BankerUI/ProfessionalDetails";
import CreateNewPasswordForBanker from "../views/BankerUI/CreateNewPasswordForBanker";
import ComplianceAdminLogin from "../views/BankerUI/ComplianceAdminLogin";
// import ApplicantUnderwritingCriteria from "../views/BankerUI/ApplicantUnderwritingCriteria";
import BankerProfile from "../views/BankerUI/BankerProfile";
import AddEditSponsers from "../views/BankerUI/AddEditSponsers";
import LoanApplicationDetails from "../views/BankerUI/LoanApplicationDetails";
import BankerReports from "../views/BankerUI/BankerReports";
import NewReportsPage from "../views/BankerUI/NewReportsPage";

import LiveAccountBalancesForBanker from "../views/BankerUI/LiveAccountBalancesForBanker";
import AdvancesAndRepaymentsForBanker from "../views/BankerUI/AdvancesAndRepaymentsForBanker";
import DataInsightsForBanker from "../views/BankerUI/DataInsightsForBanker";

//Loan Officer UI
import EnterEmailForLoanOfficer from "../views/LoanOfficerUI/EnterEmailForLoanOfficer";
import AccountLoginForLoanOfficer from "../views/LoanOfficerUI/AccountLoginForLoanOfficer";
//import RecoveryDetailsForLoanOfficer from "../views/LoanOfficerUI/RecoveryDetails"
import VerifyEmailOtpForLoanOfficer from "../views/LoanOfficerUI/VerifyEmailOtpForLoanOfficer";
import PersonalDetailsForLoanOfficer from "../views/LoanOfficerUI/PersonalDetailsForLoanOfficer";
import ProfessionalDetailsForLoanOfficer from "../views/LoanOfficerUI/ProfessionalDetailsForLoanOfficer";
import CreateNewPasswordForLoanOfficer from "../views/LoanOfficerUI/CreateNewPasswordForLoanOfficer";
import ForgotLoanOfficerPassword from "../views/LoanOfficerUI/ForgotLoanOfficerPassword";
import LoanOfficerDashboard from "../views/LoanOfficerUI/LoanOfficerDashboard";
import LoanOfficerRevisionRequest from "../views/LoanOfficerUI/LoanOfficerRevisionRequest";
import LoanOfficerProfile from "../views/LoanOfficerUI/LoanOfficerProfile";
import CreateNewPasswordForUser from "../views/NewApplication/CreateNewPasswordForUser";
import ForgotUserLoginPasswordSendOTP from "../views/NewApplication/ForgotUserLoginPasswordSendOTP";
import ForgotBankerLoginPasswordSendOTP from "../views/BankerUI/ForgotBankerLoginPasswordSendOTP";
import ForgotLoanOfficerLoginPasswordSendOTP from "../views/LoanOfficerUI/ForgotLoanOfficerLoginPasswordSendOTP";
import LoanApplicationsForLoanOfficer from "../views/LoanOfficerUI/LoanApplicationsForLoanOfficer";
// import LiveAccountBalances from "../views/BankerUI/LiveAccountBalances";
// import AdvancesAndRepayments from "../views/BankerUI/AdvancesAndRepayments";
// import DataInsights from "../views/BankerUI/DataInsights";
import LoanOfficerReports from "../views/LoanOfficerUI/LoanOfficerReports";


//bank admin
import BankAdminLogin from "../views/BankAdmin/BankAdminLogin";
import CreateBankAdminAccount from "../views/BankAdmin/CreateBankAdminAccount";
import BankAdminVerifyOtp from "../views/BankAdmin/BankAdminVerifyOtp";
import BankAdminPersonalDetails from "../views/BankAdmin/BankAdminPersonalDetails";
import CreateBankAdminPassword from "../views/BankAdmin/CreateBankAdminPassword";
import BankAdminProfessionalDetails from "../views/BankAdmin/BankAdminProfessionalDetails";
import BankAdminDashboard from "../views/BankAdmin/BankAdminDashboard";
import BankAdminProfile from "../views/BankAdmin/BankAdminProfile";
import ChangeHistory from "../views/BankAdmin/ChangeHistory";
// Firm Admin
import FirmAdminLogin from "../views/FirmAdmin/FirmAdminLogin";
import FirmAdminDashboard from "../views/FirmAdmin/FirmAdminDashboard";
import FirmAdminSponsersDetails from "../views/FirmAdmin/FirmAdminSponsersDetails";
import FirmAdminFacilityDetails from "../views/FirmAdmin/FirmAdminFacilityDetails";
import LiveAccountBalances from "../views/FirmAdmin/LiveAccountBalancesForFirmAdmin";
import DataInsights from "../views/FirmAdmin/DataInsightsForFirmAdmin";
import AdvancesAndRepayments from "../views/FirmAdmin/AdvancesAndRepaymentsForFirmAdmin";

import ComplianceAdminDashboard from "../views/ComplianceAdministrator/ComplianceAdminDashboard";
import LoanApplicationsForComplianceAdmin from "../views/ComplianceAdministrator/LoanApplicationsForComplianceAdmin";
import LiveAccountBalancesForCompliance from "../views/ComplianceAdministrator/LiveAccountBalancesForComplianceAdmin";
import FirmDashboardForComplianceAdmin from "../views/ComplianceAdministrator/FirmDashboardForComplianceAdmin";
import FacilityDetailsForComplianceAdmin from "../views/ComplianceAdministrator/FacilityDetailsForComplianceAdmin";

import FirmDashboardForSeniorBanker from "../views/BankerUI/FirmDashboardForSeniorBanker";
import FacilityDetailsForBanker from "../views/BankerUI/FacilityDetailsForBanker";

import LoginNewPage from "../components/LoginNew/LoginNewPage";
import RoleLoginClient from "../views/RoleLogin/RoleLoginClient";
import RoleLoginBanker from "../views/RoleLogin/RoleLoginBanker";
import RoleLoginSuperAdmin from "../views/RoleLogin/RoleLoginSuperAdmin";
import RoleLoginLoanOfficer from "../views/RoleLogin/RoleLoginLoanOfficer";
import RoleLoginComplianceAdmin from "../views/RoleLogin/RoleLoginComplianceAdmin";
import MicrosoftSSOResponse from "../views/SSO/MicrosoftSSOResponse";
import MicrosoftAuthCallback from "../views/SSO/MicrosoftAuthCallback";


export const routes = {
    // login: {
    //     path: "/login",
    //     basePath: "/login",
    //     name: "Login",
    //     component: Login,
    // },
    loginNewPage: {
        path: "/",
        basePath: "/",
        name: "LoginNewPage",
        component: LoginNewPage,
    },
    roleLoginClient: {
        path: "/login/client",
        basePath: "/login/client",
        name: "RoleLoginClient",
        component: RoleLoginClient,
    },
    roleLoginBanker: {
        path: "/login/banker",
        basePath: "/login/banker",
        name: "RoleLoginBanker",
        component: RoleLoginBanker,
    },
    roleLoginSuperAdmin: {
        path: "/login/super-admin",
        basePath: "/login/super-admin",
        name: "RoleLoginSuperAdmin",
        component: RoleLoginSuperAdmin,
    },
    roleLoginLoanOfficer: {
        path: "/login/loan-officer",
        basePath: "/login/loan-officer",
        name: "RoleLoginLoanOfficer",
        component: RoleLoginLoanOfficer,
    },
    roleLoginComplianceAdmin: {
        path: "/login/compliance-admin",
        basePath: "/login/compliance-admin",
        name: "RoleLoginComplianceAdmin",
        component: RoleLoginComplianceAdmin,
    },
    ssoMicrosoftResponse: {
        path: "/sso-response",
        basePath: "/sso-response",
        name: "MicrosoftSSOResponse",
        component: MicrosoftSSOResponse,
    },
    microsoftAuthCallback: {
        path: "/auth-callback",
        basePath: "/auth-callback",
        name: "MicrosoftAuthCallback",
        component: MicrosoftAuthCallback,
    },
    homePage: {
        path: "/homepage",
        basePath: "/homepage",
        name: "HomePage",
        component: HomePage,
    },
    verifyEmail: {
        path: "/createaccount",
        basePath: "/createaccount",
        name: "VerifyEmail",
        component: VerifyEmail,
    },
    // newHomePage: {
    //     path: "/",
    //     basePath: "/",
    //     name: "VerifyOtp",
    //     component: VerifyOtp,
    // },
    VerifyOtp: {
        path: "/verifyotp",
        basePath: "/verifyotp",
        name: "VerifyOtp",
        component: VerifyOtp,
    },
    ApplicantsDetails: {
        path: "/applicant-details",
        basePath: "/applicant-details",
        name: "ApplicantDetails",
        component: ApplicantsDetails,
    },
    ProofOfTrust: {
        path: "/proof-of-trust",
        basePath: "/proof-of-trust",
        name: "ProofOfTrust",
        component: ProofOfTrust,
    },
    applicantsIdentification: {
        path: "/applicant-identification",
        basePath: "/applicant-identification",
        name: "applicantsIdentification",
        component: ApplicantsIdentification,
    },
    coBorrowersDetails: {
        path: "/co-BorrowersDetails",
        basePath: "/co-BorrowersDetails",
        name: "co-BorrowersDetails",
        component: CoBorrowersDetails,
    },
    identificationOfcoBorrower: {
        path: "/identificationOfCo-Borrower",
        basePath: "/identificationOfCo-Borrower",
        name: "identificationOfCo-Borrower",
        component: IdentificationOfCoBorrower,
    },
    applicantProfessionalDetails: {
        path: "/applicantProfessionalDetails",
        basePath: "/applicantProfessionalDetails",
        name: "applicantProfessionalDetails",
        component: ApplicantProfessionalDetails,
    },
    uploaddocuments: {
        path: "/upload-documents",
        basePath: "/upload-documents",
        name: "UploadDocuments",
        component: UploadDocumentsOne,
    },
    uploaddocumentpreview: {
        path: "/preview-upload-documents",
        basePath: "/preview-upload-documents",
        name: "UploadDocumentsPreview",
        component: UploadDocumentsPreview,
    },
    liquidity: {
        path: "/liquidity",
        basePath: "/liquidity",
        name: "liquidity",
        component: Liquidity,
    },
    realestateassets: {
        path: "/real-estate-assets",
        basePath: "/real-estate-assets",
        name: "RealEstateAssets",
        component: RealEstateAssets,
    },
    businessAssets: {
        path: "/business-assets",
        basePath: "/business-assets",
        name: "businessAssets",
        component: BusinessAssets,
    },
    partnershipInterests: {
        path: "/partnership-interests",
        basePath: "/partnership-interests",
        name: "partnershipInterests",
        component: PartnershipInterests,
    },
    personalHolding: {
        path: "/personal-holding",
        basePath: "/personal-holding",
        name: "personalHolding",
        component: PersonalHolding,
    },
    liabilitiesForm: {
        path: "/liabilities",
        basePath: "/liabilities",
        name: "liabilities",
        component: LiabilitiesForm,
    },
    incomeSources: {
        path: "/income-sources",
        basePath: "/income-sources",
        name: "incomeSources",
        component: IncomeSources,
    },
    expenses: {
        path: "/expenses",
        basePath: "/expenses",
        name: "expenses",
        component: Expenses,
    },
    balanceSheetAssets: {
        path: "/balance-sheet-assets",
        basePath: "/balance-sheet-assets",
        name: "balancesheetassets",
        component: BalanceSheetAssets,
    },
    balanceSheetTotalAssets: {
        path: "/balance-sheet-total-assets",
        basePath: "/balance-sheet-total-assets",
        name: "balanceSheetTotalAssets",
        component: BalanceSheetTotalAssets,
    },
    balanceSheetTotalLiabilities: {
        path: "/balance-sheet-total-liabilities",
        basePath: "/balance-sheet-total-liabilities",
        name: "/BalanceSheetTotalLiabilities",
        component: BalanceSheetTotalLiabilities,
    },
    questionnaire: {
        path: "/questionnaire",
        basePath: "/questionnaire",
        name: "/questionnaire",
        component: Questionnaire,
    },
    dashboard: {
        path: "/dashboard",
        basePath: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
    },
    // registeredEmail: {
    //     path: "/clientlogin",
    //     basePath: "/clientlogin",
    //     name: "registeredEmail",
    //     component: RegisteredEmail,
    // },
    registeredEmailOtp: {
        path: "/userlogin-otp",
        basePath: "/userlogin-otp",
        name: "registeredEmailOtp",
        component: RegisteredEmailOtp,
    },
    createNewPasswordForUser: {
        path: "/createNewPasswordForUser",
        basePath: "/createNewPasswordForUser",
        name: "createNewPasswordForUser",
        component: CreateNewPasswordForUser,
    },
    myApplications: {
        path: "/my-applications",
        basePath: "/my-applications",
        name: "MyApplications",
        component: MyApplications,
    },
    applicationStatus: {
        path: "/applicationstatus",
        basePath: "/applicationstatus",
        name: "applicationStatus",
        component: ApplicationStatus,
    },
    bankerdashboard: {
        path: "/banker-dashboard",
        basePath: "/banker-dashboard",
        name: "BankerDashboard",
        component: BankerDashboard,
    },
    complianceadmindashboard: {
        path: "/compliance-admin-dashboard",
        basePath: "/compliance-admin-dashboard",
        name: "ComplianceAdminDashboard",
        component: ComplianceAdminDashboard,
    },
    bankerprofile: {
        path: "/banker-profile",
        basePath: "/banker-profile",
        name: "BankerProfile",
        component: BankerProfile,
    },
    // applicantUnderwritingCriteria: {
    //     path: "/applicantUnderwritingCriteria",
    //     basePath: "/applicantUnderwritingCriteria",
    //     name: "ApplicantUnderwritingCriteria",
    //     component: ApplicantUnderwritingCriteria,
    // },
    loanapplication: {
        path: "/loan-application",
        basePath: "/loan-application",
        name: "LoanApplication",
        component: LoanApplications,
    },
    loanApplicationsForComplianceAdmin: {
        path: "/loan-application-for-compliance-admin",
        basePath: "/loan-application-for-compliance-admin",
        name: "LoanApplicationsForComplianceAdmin",
        component: LoanApplicationsForComplianceAdmin,
    },
    revisionrequest: {
        path: "/revision-request",
        basePath: "/revision-request",
        name: "RevisionRequest",
        component: RevisionRequest,
    },
    sponsors: {
        path: "/sponsors",
        basePath: "/sponsors",
        name: "Sponsors",
        component: Sponsors,
    },
    addEditSponsers: {
        path: "/add-edit-sponsers",
        basePath: "/add-edit-sponsers",
        name: "AddEditSponsers",
        component: AddEditSponsers,
    },
    facilityDetails: {
        path: "/facility-details",
        basePath: "/facility-details",
        name: "FacilityDetails",
        component: FacilityDetails,
    },
    enterEmail: {
        path: "/createbankeraccount",
        basePath: "/createbankeraccount",
        name: "enterEmail",
        component: EnterEmail,
    },
    verifyEmailOtp: {
        path: "/verify-email-otp",
        basePath: "/verify-email-otp",
        name: "verifyEmailOtp",
        component: VerifyEmailOtp,
    },
    verifyBankerRolesOtp: {
        path: "/verify-banker-roles-otp",
        basePath: "/verify-banker-roles-otp",
        name: "verifyBankerRolesOtp",
        component: VerifyBankerRolesOtp,
    },
    // accountLogin: {
    //     path: "/bankerlogin",
    //     basePath: "/bankerlogin",
    //     name: "accountLogin",
    //     component: AccountLogin,
    // },
    // complianceAdminLogin: {
    //     path: "/complianceadminlogin",
    //     basePath: "/complianceadminlogin",
    //     name: "complianceAdminLogin",
    //     component: ComplianceAdminLogin,
    // },
    forgotUserLoginPassword: {
        path: "/forgotUserLoginPassword",
        basePath: "forgotUserLoginPassword",
        name: "ForgotUserLoginPassword",
        component: ForgotUserLoginPassword,
    },
    ForgottenPassword: {
        path: "/forgottenPassword",
        basePath: "forgottenPassword",
        name: "ForgottenPassword",
        component: ForgottenPassword,
    },
    personalDetails: {
        path: "/personal-details",
        basePath: "/personal-details",
        name: "personalDetails",
        component: PersonalDetails,
    },
    professionalDetails: {
        path: "/professional-details",
        basePath: "/professional-details",
        name: "professionalDetails",
        component: ProfessionalDetails,
    },
    createNewPasswordForBanker: {
        path: "/createNewPasswordForBanker",
        basePath: "/createNewPasswordForBanker",
        name: "createNewPasswordForBanker",
        component: CreateNewPasswordForBanker,
    },
    enterEmailForLoanOfficer: {
        path: "/createloanofficeraccount",
        basePath: "/createloanofficeraccount",
        name: "enterEmailForLoanOfficer",
        component: EnterEmailForLoanOfficer,
    },
    verifyEmailOtpForLoanOfficer: {
        path: "/verifyEmailOtpForLoanOfficer",
        basePath: "/verifyEmailOtpForLoanOfficer",
        name: "verifyEmailOtpForLoanOfficer",
        component: VerifyEmailOtpForLoanOfficer,
    },
    // accountLoginForLoanOfficer: {
    //     path: "/loanofficerlogin",
    //     basePath: "/loanofficerlogin",
    //     name: "accountLoginForLoanOfficer",
    //     component: AccountLoginForLoanOfficer,
    // },
    forgotLoanOfficerPassword: {
        path: "/forgotLoanOfficerPassword",
        basePath: "/forgotLoanOfficerPassword",
        name: "forgotLoanOfficerPassword",
        component: ForgotLoanOfficerPassword,
    },
    personalDetailsForLoanOfficer: {
        path: "/personalDetailsForLoanOfficer",
        basePath: "/personalDetailsForLoanOfficer",
        name: "personalDetailsForLoanOfficer",
        component: PersonalDetailsForLoanOfficer,
    },
    professionalDetailsForLoanOfficer: {
        path: "/professionalDetailsForLoanOfficer",
        basePath: "/professionalDetailsForLoanOfficer",
        name: "professionalDetailsForLoanOfficer",
        component: ProfessionalDetailsForLoanOfficer,
    },
    createNewPasswordForLoanOfficer: {
        path: "/createNewPasswordForLoanOfficer",
        basePath: "/createNewPasswordForLoanOfficer",
        name: "createNewPasswordForLoanOfficer",
        component: CreateNewPasswordForLoanOfficer,
    },
    loanApplicationDetails: {
        path: "/loanApplicationDetails",
        basePath: "/loanApplicationDetails",
        name: "loanApplicationDetails",
        component: LoanApplicationDetails,
    },
    loanOfficerDashboard: {
        path: "/loanOfficerDashboard",
        basePath: "/loanOfficerDashboard",
        name: "LoanOfficerDashboard",
        component: LoanOfficerDashboard,
    },
    loanOfficerRevisionRequest: {
        path: "/loanOfficerRevisionRequest",
        basePath: "/loanOfficerRevisionRequest",
        name: "LoanOfficerRevisionRequest",
        component: LoanOfficerRevisionRequest,
    },
    loanOfficerProfile: {
        path: "/loan-Officer-profile",
        basePath: "/loan-Officer-profile",
        name: "LoanOfficerProfile",
        component: LoanOfficerProfile,
    },
    forgotUserLoginPasswordSendOTP: {
        path: "/forgotUserLoginPasswordSendOTP",
        basePath: "/forgotUserLoginPasswordSendOTP",
        name: "ForgotUserLoginPasswordSendOTP",
        component: ForgotUserLoginPasswordSendOTP,
    },
    forgotBankerLoginPasswordSendOTP: {
        path: "/forgotBankerLoginPasswordSendOTP",
        basePath: "/forgotBankerLoginPasswordSendOTP",
        name: "ForgotBankerLoginPasswordSendOTP",
        component: ForgotBankerLoginPasswordSendOTP,
    },
    forgotLoanOfficerLoginPasswordSendOTP: {
        path: "/forgotLoanOfficerLoginPasswordSendOTP",
        basePath: "/forgotLoanOfficerLoginPasswordSendOTP",
        name: "ForgotLoanOfficerLoginPasswordSendOTP",
        component: ForgotLoanOfficerLoginPasswordSendOTP,
    },
    loanApplicationsForLoanOfficer: {
        path: "/loanApplicationsForLoanOfficer",
        basePath: "/loanApplicationsForLoanOfficer",
        name: "LoanApplicationsForLoanOfficer",
        component: LoanApplicationsForLoanOfficer,
    },
    liveAccountBalances: {
        path: "/liveAccountBalances",
        basePath: "/liveAccountBalances",
        name: "LiveAccountBalances",
        component: LiveAccountBalances,
    },
    advancesAndRepayments: {
        path: "/advancesAndRepayments",
        basePath: "/advancesAndRepayments",
        name: "AdvancesAndRepayments",
        component: AdvancesAndRepayments,
    },
    dataInsights: {
        path: "/dataInsights",
        basePath: "/dataInsights",
        name: "DataInsights",
        component: DataInsights,
    },
    bankAdminLogin: {
        path: "/bankadminlogin",
        basePath: "/bankAdminLogin",
        name: "BankAdminLogin",
        component: BankAdminLogin,
    },
    createsuperadmin: {
        path: "/createsuperadmin",
        basePath: "/createsuperadmin",
        name: "CreateBankAdminAccount",
        component: CreateBankAdminAccount,
    },
    bankadminverifyotp: {
        path: "/bankadminverifyotp",
        basePath: "/bankadminverifyotp",
        name: "BankAdminVerifyOtp",
        component: BankAdminVerifyOtp,
    },
    bankadminpersonaldetails: {
        path: "/bankadminpersonaldetails",
        basePath: "/bankadminpersonaldetails",
        name: "BankAdminPersonalDetails",
        component: BankAdminPersonalDetails,
    },
    bankadminprofessionaldetails: {
        path: "/bankadminprofessionaldetails",
        basePath: "/bankadminprofessionaldetails",
        name: "BankAdminProfessionalDetails",
        component: BankAdminProfessionalDetails,
    },
    createbankadminpassword: {
        path: "/createbankadminpassword",
        basePath: "/createbankadminpassword",
        name: "CreateBankAdminPassword",
        component: CreateBankAdminPassword,
    },
    bankadmindashboard: {
        path: "/bankadmindashboard",
        basePath: "/bankadmindashboard",
        name: "BankAdminDashboard",
        component: BankAdminDashboard,
    },
    changeHistory: {
        path: "/change-history",
        basePath: "/change-history",
        name: "ChangeHistory",
        component: ChangeHistory,
    },
    bankerReports: {
        path: "/bankerReports",
        basePath: "/bankerReports",
        name: "BankerReports",
        component: BankerReports,  //
    },
    loanOfficerReports: {
        path: "/loanOfficerReports",
        basePath: "/loanOfficerReports",
        name: "LoanOfficerReports",
        component: LoanOfficerReports,
    },
    newReports: {
        path: "/new-reports",
        basePath: "/new-reports",
        name: "NewReportsPage",
        component: NewReportsPage,
    },
    firmadminlogin: {
        path: "/firmadminlogin",
        basePath: "/firmadminlogin",
        name: "FirmAdminLogin",
        component: FirmAdminLogin,
    },
    firmadmindashboard: {
        path: "/firmadmindashboard",
        basePath: "/firmadmindashboard",
        name: "FirmAdminDashboard",
        component: FirmAdminDashboard,
    },
    bankadminprofile: {
        path: "/bankadminprofile",
        basePath: "/bankadminprofile",
        name: "BankAdminProfile",
        component: BankAdminProfile,
    },
    firmadminsponsersdetails: {
        path: "/firmadminsponsersdetails",
        basePath: "/firmadminsponsersdetails",
        name: "FirmAdminSponsersDetails",
        component: FirmAdminSponsersDetails,
    },
    firmadminfacilitydetails: {
        path: "/firm-admin-facility-details",
        basePath: "/firm-admin-facility-details",
        name: "FirmAdminFacilityDetails",
        component: FirmAdminFacilityDetails,
    },
    //  liveAccountBalancesForBanker: {
    //     path: "/liveAccountBalancesForBanker",
    //     basePath: "/liveAccountBalancesForBanker",
    //     name: "LiveAccountBalancesForBanker",
    //     component: LiveAccountBalancesForBanker,
    // },
    // advancesAndRepaymentsForBanker: {
    //     path: "/advancesAndRepaymentsForBanker",
    //     basePath: "/advancesAndRepaymentsForBanker",
    //     name: "AdvancesAndRepaymentsForBanker",
    //     component: AdvancesAndRepaymentsForBanker,
    // },
    // dataInsightsForBanker: {
    //     path: "/dataInsightsForBanker",
    //     basePath: "/dataInsightsForBanker",
    //     name: "DataInsightsForBanker",
    //     component: DataInsightsForBanker,
    // },

    liveAccountBalancesForBanker: {
        path: "/live-account-balances-for-banker",
        basePath: "/live-account-balances-for-banker",
        name: "LiveAccountBalancesForBanker",
        component: LiveAccountBalancesForBanker,
    },
    advancesAndRepaymentsForBanker: {
        path: "/advances-and-repayments-for-banker",
        basePath: "/advances-and-repayments-for-banker",
        name: "AdvancesAndRepaymentsForBanker",
        component: AdvancesAndRepaymentsForBanker,
    },
    dataInsightsForBanker: {
        path: "/data-insights-for-banker",
        basePath: "/data-insights-for-banker",
        name: "DataInsightsForBanker",
        component: DataInsightsForBanker,
    },
    liveAccountBalancesForCompliance: {
        path: "/live-account-balances-for-compliance",
        basePath: "/live-account-balances-for-compliance",
        name: "LiveAccountBalancesForCompliance",
        component: LiveAccountBalancesForCompliance,
    },
    complianceAdminFirmDashboard: {
        path: "/compliance-admin-firm-dashboard",
        basePath: "/compliance-admin-firm-dashboard",
        name: "FirmDashboardForComplianceAdmin",
        component: FirmDashboardForComplianceAdmin,
    },
    complianceAdminFacilityDetails: {
        path: "/compliance-admin-facility-details",
        basePath: "/compliance-admin-facility-details",
        name: "FacilityDetailsForComplianceAdmin",
        component: FacilityDetailsForComplianceAdmin,
    },
    complianceAdminSponserDetails: {
        path: "/compliance-admin-sponser-details",
        basePath: "/compliance-admin-sponser-details",
        name: "ComplianceAdminSponserDetails",
        component: FirmAdminSponsersDetails,
    },
    seniorBankerFirmDashboard: {
        path: "/senior-banker-firm-dashboard",
        basePath: "/senior-banker-firm-dashboard",
        name: "FirmDashboardForSeniorBanker",
        component: FirmDashboardForSeniorBanker,
    },
    seniorBankerFacilityDetails: {
        path: "/senior-banker-facility-details",
        basePath: "/senior-banker-facility-details",
        name: "FacilityDetailsForBanker",
        component: FacilityDetailsForBanker,
    },

};

export const publicRoutes = [
    // routes.login,
    routes.verifyEmail,
    routes.VerifyOtp,
    // routes.newHomePage,
    // routes.registeredEmail,
    routes.registeredEmailOtp,
    routes.enterEmail,
    // routes.accountLogin,
    // routes.complianceAdminLogin,
    routes.forgotUserLoginPassword,
    routes.ForgottenPassword,
    routes.forgotLoanOfficerPassword,
    routes.verifyEmailOtp,
    routes.verifyBankerRolesOtp,
    routes.enterEmailForLoanOfficer,
    routes.verifyEmailOtpForLoanOfficer,
    // routes.accountLoginForLoanOfficer,
    routes.applicationStatus,
    routes.forgotUserLoginPasswordSendOTP,
    routes.forgotBankerLoginPasswordSendOTP,
    routes.forgotLoanOfficerLoginPasswordSendOTP,
    routes.bankAdminLogin,
    routes.createsuperadmin,
    routes.bankadminverifyotp,
    routes.firmadminlogin,
    // routes.firmadmindashboard,

    routes.loginNewPage,
    routes.roleLoginClient,
    routes.roleLoginBanker,
    routes.roleLoginSuperAdmin,
    routes.roleLoginLoanOfficer,
    routes.roleLoginComplianceAdmin,
    routes.ssoMicrosoftResponse,
    routes.microsoftAuthCallback,

];

export const privateRoutes = [
    routes.homePage,
    //client flow
    routes.ApplicantsDetails,
    routes.ProofOfTrust,
    routes.applicantsIdentification,
    routes.coBorrowersDetails,
    routes.identificationOfcoBorrower,
    routes.applicantProfessionalDetails,
    routes.uploaddocuments,
    routes.uploaddocumentpreview,
    routes.liquidity,
    routes.realestateassets,
    routes.businessAssets,
    routes.partnershipInterests,
    routes.personalHolding,
    routes.liabilitiesForm,
    routes.incomeSources,
    routes.expenses,
    routes.balanceSheetAssets,
    routes.balanceSheetTotalAssets,
    routes.balanceSheetTotalLiabilities,
    routes.questionnaire,
    routes.dashboard,
    routes.myApplications,
    routes.createNewPasswordForUser,
  

    //banker
    routes.personalDetails,
    routes.professionalDetails,
    routes.loanapplication,
    routes.revisionrequest,
    routes.bankerdashboard,
    routes.bankerprofile,
    routes.sponsors,
    routes.addEditSponsers,
    routes.facilityDetails,
    routes.loanApplicationDetails,
    routes.createNewPasswordForBanker,
    routes.liveAccountBalancesForBanker,
    routes.advancesAndRepaymentsForBanker,
    routes.dataInsightsForBanker,
    routes.bankerReports,
    routes.newReports,

    //loan officer
    routes.loanOfficerDashboard,
    routes.loanOfficerRevisionRequest,
    routes.loanOfficerProfile,
    routes.loanApplicationsForLoanOfficer,
    routes.personalDetailsForLoanOfficer,
    routes.professionalDetailsForLoanOfficer,
    routes.createNewPasswordForLoanOfficer,
    routes.loanOfficerReports,

    //bank admin
    routes.bankadminpersonaldetails,
    routes.bankadminprofessionaldetails,
    routes.createbankadminpassword,
    routes.bankadmindashboard,
    routes.bankadminprofile,
    routes.changeHistory,

    // Firm admin
    routes.firmadmindashboard,
    routes.firmadminsponsersdetails,
    routes.firmadminfacilitydetails,
    routes.liveAccountBalances,
    routes.advancesAndRepayments,
    routes.dataInsights,

    //Compliance Admin
    routes.complianceadmindashboard,
    routes.loanApplicationsForComplianceAdmin,
    routes.liveAccountBalancesForCompliance,
    routes.complianceAdminFirmDashboard,
    routes.complianceAdminFacilityDetails,
    routes.complianceAdminSponserDetails,
    routes.seniorBankerFirmDashboard,
    routes.seniorBankerFacilityDetails,

]